import React, { useState, Suspense } from 'react';

import questions from './questions.json';
import LoadingSpinnerWithImage from '../Components/LoadingSpinnerWithImage';

const loadComponent = (componentName: string) => {
    return React.lazy(() => import(`./${componentName}`));
};

const Question: React.FC = () => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

    // Calculate the progress percentage
    const totalQuestions = questions.length;
    const progressPercentage = ((currentQuestionIndex + 1) / totalQuestions) * 100;

    const currentComponentName = questions[currentQuestionIndex].component;
    const CurrentComponent = loadComponent(currentComponentName);

    const goToNext = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    const goToPrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };


    return (
        <>
            {/* Progress Bar Placeholder */}
            <div className="progress" style={{ height: "10px", borderRadius: 0 }}>
                {/* Set the width of the progress bar dynamically based on progressPercentage */}
                <div className="progress-bar" style={{ width: `${progressPercentage}%`, background: "black" }}></div>
            </div>

            {/* Content (Quiz Question Area) */}
            <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                <div className="p-5 bg-white w-100" style={{ height: "100%" }}>
                    <Suspense fallback={<LoadingSpinnerWithImage />}>
                        <div className="fade-enter fade-enter-active">
                            <CurrentComponent questionIndex={currentQuestionIndex} />
                        </div>
                    </Suspense>
                </div>
            </div>

            {/* Navigation Buttons */}
            <div
                className="fixed-bottom d-flex justify-content-between align-items-center px-4 py-3 border-top bg-white"
                style={{ zIndex: 1000 }}
            >
                <button
                    onClick={goToPrevious}
                    className="btn btn-secondary btn-lg fs-6"
                    style={{ borderRadius: 0 }}
                >
                    ANTERIOR
                </button>

                {/* Copyright Text, centered vertically */}
                <p className="mb-0" style={{ margin: '0 auto' }}>
                    &copy; {new Date().getFullYear()} Plano Invisible. All rights reserved.
                </p>

                <button
                    onClick={goToNext}
                    className="btn btn-dark btn-lg fs-6"
                    style={{ borderRadius: 0 }}
                >
                    SIGUIENTE
                </button>
            </div>
        </>
    );
};

export default Question;